import { render, staticRenderFns } from "./MyRecord.vue?vue&type=template&id=7e27bce7&scoped=true&"
import script from "./MyRecord.vue?vue&type=script&lang=js&"
export * from "./MyRecord.vue?vue&type=script&lang=js&"
import style0 from "./MyRecord.vue?vue&type=style&index=0&id=7e27bce7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e27bce7",
  null
  
)

export default component.exports